<template>
  <div class="container-fluid">
    <div class="row">
      <h1 class="page-header">{{ dado.nome }}</h1>
      <div class="row">
        <div class="col-sm-4 col-md-3">
          <div :class="['form-group', { 'has-error': errors.has('data') }]">
            <label class="control-label custom-font">Data</label>
            <div class="input-group">
              <span class="input-group-addon">
                <font-awesome-icon :icon="'calendar-alt'" />
              </span>
              <datepicker
                ref="data"
                v-model="model.data"
                name="data"
                v-validate="'required'"
              ></datepicker>
            </div>
            <small
              v-if="errors.has('data')"
              data-bv-validator="notempty"
              data-bv-validator-for="data"
              class="help-block"
              style=""
              >{{ errors.first('data') }}</small
            >
          </div>
        </div>
        <div :class="['col-xs-12', { 'col-sm-4 col-md-3': !isValueTexto() }]">
          <div
            :class="[
              'form-group',
              {
                'has-error': errors.has(isValueTexto() ? 'resposta' : 'valor')
              }
            ]"
          >
            <label
              class="control-label custom-font"
              v-text="isValueTexto() ? 'Resposta' : 'Valor'"
            ></label>

            <div
              v-if="isValueInteiro() || isValueDecimal()"
              class="inputgroupcontainer"
            >
              <div class="input-group">
                <span class="input-group-addon">
                  <font-awesome-icon :icon="'money-bill'" />
                </span>
                <input
                  ref="inteiro"
                  @keyup.enter="save()"
                  v-if="isValueInteiro()"
                  name="valor"
                  v-model="model.value"
                  class="form-control"
                  v-validate="{
                    required: true,
                    regex: /^[\+|\-]?[0-9]+$/
                  }"
                  type="text"
                />
                <money
                  ref="decimal"
                  @keyup.enter="save()"
                  v-if="isValueDecimal()"
                  name="valor"
                  v-model="model.value"
                  class="form-control"
                  v-validate="'required'"
                  v-bind="configMoney()"
                />
              </div>
              <small
                v-if="errors.has('valor')"
                data-bv-validator="notempty"
                data-bv-validator-for="valor"
                class="help-block"
                style=""
                >{{ errors.first('valor') }}</small
              >
            </div>

            <div v-if="isValueTexto()">
              <textarea
                ref="resposta"
                @keyup.enter="save()"
                name="resposta"
                v-model="model.value"
                class="form-control"
                v-validate="'required'"
                rows="7"
                placeholder="Digite aqui sua resposta..."
              ></textarea>
              <small
                v-if="errors.has('resposta')"
                data-bv-validator="notempty"
                data-bv-validator-for="resposta"
                class="help-block"
                style=""
                >{{ errors.first('resposta') }}
              </small>
            </div>
          </div>
        </div>

        <div class="col-xs-12">
          <div class="form-group">
            <label class="control-label custom-font">Observação</label>
            <textarea
              ref="observacao"
              rows="7"
              name="observacao"
              v-model="model.observacao"
              placeholder="Digite aqui sua observação..."
              class="form-control"
            >
            </textarea>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="form-group" style="margin-top: 30px">
            <div>
              <button @click.prevent="save()" class="btn btn-default">
                <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
                <font-awesome-icon v-else :icon="'save'" />
                Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userBase from '@/views/admin/dados/user/UserBase'
import { request } from '@/request'
import datepicker from '@/components/common/Datepicker'

export default {
  extends: userBase,
  components: { datepicker },
  data() {
    return {
      carregando: false,
      dado: {
        codigo: 0,
        nome: '',
        tipoValor: '',
        periodicidade: ''
      },
      model: {
        id: '',
        data: '',
        value: '',
        observacao: ''
      }
    }
  },
  beforecreate() {
    if (!this.$store.state.islogged) {
      this.$router.push('/login')
    }
  },
  created() {
    this.loadDado()

    if (this.isUpdated()) this.loadValue()
  },
  mounted() {
    var r = this.$refs
    if (this.isUpdated()) {
      setTimeout(() => {
        if (this.isValueInteiro() || this.isValueDecimal()) {
          if (this.isValueInteiro()) {
            r.inteiro.focus()
          } else {
            r.decimal.$el.focus()
          }
        } else {
          r.resposta.focus()
        }
      }, 500)
    } else {
      setTimeout(() => {
        this.setDateDefault()
      }, 500)
    }
  },
  methods: {
    handleLoading() {
      this.carregando = !this.carregando
    },
    loadDado() {
      var me = this
      var params = me.$router.history.current.params

      request
        .get(`dado/get/${params.DAD_IDDADO}`, null)
        .then(r => {
          if (r.status) {
            me.dado.codigo = r.data.codigo
            me.dado.nome = r.data.nome
            me.dado.tipoValor = r.data.tipoValor
            me.dado.periodicidade = r.data.periodicidade.descricao
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    loadValue() {
      var me = this
      var params = me.$router.history.current.params

      request
        .post('dado/valor/get', { DVA_IDDADOVALOR: params.DVA_IDDADOVALOR })
        .then(response => {
          var d = response.data.data
          me.model.id = d.DVA_IDDADOVALOR
          me.model.data = new Date(d.DVA_DTDADOVALOR)

          me.dado.codigo = d.dado.DAD_IDDADO
          me.dado.tipoValor = d.dado.DAD_CDTIPOVALOR

          if (me.isValueInteiro() || me.isValueDecimal()) {
            me.model.value = me.isValueInteiro()
              ? parseInt(d.DVA_VLDADOVALOR)
              : parseFloat(d.DVA_VLDADOVALOR)
          } else {
            me.model.value = d.DVA_DLDADOVALOR
          }
          me.model.observacao = d.DVA_DLOBSERVACAO
        })
        .catch(e => {
          console.log(e)
        })
    },
    isUpdated() {
      return (
        this.$router.history.current.params.hasOwnProperty('DVA_IDDADOVALOR') &&
        this.$router.history.current.params.DVA_IDDADOVALOR
      )
    },
    isValueInteiro() {
      if (this.dado.tipoValor) {
        return this.dado.tipoValor === 'I'
      }
      return false
    },
    isValueDecimal() {
      if (this.dado.tipoValor) {
        return this.dado.tipoValor === 'D'
      }
      return false
    },
    isValueTexto() {
      if (this.dado.tipoValor) {
        return this.dado.tipoValor === 'T'
      }
      return false
    },
    getValueDefault() {
      return this.isValueInteiro() || this.isValueDecimal() ? 0 : ''
    },
    setDateDefault() {
      const now = new Date()
      let month, periodoNumber

      if (this.dado.periodicidade.toLowerCase() === 'anual')
        this.model.data = new Date(now.getFullYear() - 1, 11, 31)
      else {
        switch (this.dado.periodicidade.toLowerCase()) {
          case 'semestral':
            periodoNumber = 6
            break
          case 'quadrimestral':
            periodoNumber = 4
            break
          case 'trimestral':
            periodoNumber = 3
            break
          case 'bimestral':
            periodoNumber = 2
            break
          case 'mensal':
            periodoNumber = 1
            break
        }

        const periodoAtual =
          periodoNumber > 1
            ? Math.floor((now.getMonth() + 1) / periodoNumber)
            : now.getMonth()

        if (periodoAtual === 0)
          this.model.data = new Date(now.getFullYear() - 1, 11, 31)
        else {
          month = periodoNumber * periodoAtual
          const date = new Date(now.getFullYear(), month, 1)
          date.setDate(date.getDate() - 1)
          this.model.data = date
        }
      }
    },
    configMoney() {
      return {
        decimal: ',',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    },
    saveSuccess(response) {
      this.$toastr.s('Valor foi salvo com sucesso.')
      this.$router.push({
        name: 'user_dado_valor_list',
        params: { DAD_IDDADO: this.dado.codigo }
      })
    },
    saveFail(error) {
      const { data } = error.response
      if (data.msg) {
        this.$toastr.e(data.msg)
      } else {
        this.$toastr.e(
          'Houve uma falha ao tentar salvar este item, Tente novamente daqui alguns minutos!'
        )
      }
    },
    save() {
      var me = this
      this.$validator.validateAll().then(result => {
        if (!result) {
          const element = me.$refs[this.$validator.errors.items[0].field]

          element.$el ? element.$el.focus() : element.focus()
          me.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }

        this.handleLoading()
        request
          .post('dado/valor/save', this.payload)
          .then(this.saveSuccess)
          .catch(this.saveFail)
          .finally(this.handleLoading)
      })
    }
  },
  computed: {
    dateFormat: function() {
      return (
        this.model.data.getFullYear() +
        '-' +
        (this.model.data.getMonth() + 1) +
        '-' +
        this.model.data.getDate()
      )
    },
    payload: function() {
      var m = {
        DAD_IDDADO: this.dado.codigo,
        DVA_DTDADOVALOR: this.dateFormat,
        DVA_DLOBSERVACAO: this.model.observacao
      }

      if (this.isUpdated()) {
        m.DVA_IDDADOVALOR = this.model.id
      }

      if (this.isValueInteiro() || this.isValueDecimal()) {
        m.DVA_VLDADOVALOR = this.model.value
      } else {
        m.DVA_DLDADOVALOR = this.model.value
      }

      return m
    }
  },
  watch: {
    model: {
      value(val, old) {
        if (this.isValueInteiro()) {
          if (isNaN(val) && val !== '-') {
            this.model.value = old
          }
        }
      }
    }
  }
}
</script>

<style scoped>
textarea.form-control {
  height: 150px;
}
.page-header {
  font-size: 2.8em !important;
}
.inputgroupcontainer {
  max-width: 250px;
}
.custom-font {
  font-size: 16px;
  color: #00615c;
}
.fa-calendar-alt {
  color: #00615c;
}
.fa-money-bill {
  color: #00615c;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/dados/user/ValueSave.vue